import Building from 'components/onboarding/building'
import ChoosePart from 'components/onboarding/choose-part'
import ChooseToolLibrary from 'components/onboarding/choose-tool-library'
import { useOnboarding } from 'context/onboarding-context'
import { Transition } from '@headlessui/react'

const Onboarding = () => {
  const { isVisible } = useOnboarding()

  return (
    <>
      {isVisible && (
        <div className="pointer-events-none absolute left-0 top-0 h-screen w-screen bg-gray-50/40 backdrop-blur" />
      )}
      <Transition
        show={isVisible}
        className="absolute left-0 top-0 h-screen w-screen"
        enter="transform transition duration-500 ease-in-out"
        enterFrom="opacity-0 scale-50"
        enterTo="opacity-100 scale-100"
        leave="transform duration-500 transition ease-in-out"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-50">
        <ChooseToolLibrary />
        <Building />
        <ChoosePart />
      </Transition>
    </>
  )
}

export default Onboarding
